import React from "react";
import { Modal } from "react-bootstrap";

import { Button } from "components";

type DeleteRoleModalProps = {
	show: boolean;
	onHide: () => void;
	handleSubmit: Function;
};

const DeleteRoleModal = ({
	show,
	onHide,
	handleSubmit,
}: DeleteRoleModalProps) => {
	const closeModal = () => {
		onHide();
	};

	return (
		<Modal show={show} onHide={onHide} centered>
			<Modal.Header closeButton>
				<Modal.Title as="h4" className="text-center">
					Are you sure you want to delete the role?
				</Modal.Title>
			</Modal.Header>
			<Modal.Body className="text-center">
				<Button
					onClick={closeModal}
					value="Cancel"
					variant="outline-primary"
					style={{ marginRight: "30px" }}
				/>
				<Button onClick={handleSubmit} value="Yes" />
			</Modal.Body>
		</Modal>
	);
};

export default DeleteRoleModal;
